import request from '@/common/request-axios'
import { getDeviceFingerprint } from '@/common/device'

const AuthAPI = {
  sendVerificationCode(phone) {
    return request.post(
      '/api/v1/auth/verification/send',
      {
        phone,
        device_fingerprint: getDeviceFingerprint()
      },
      {
        showError: false
      }
    )
  },

  phoneLogin(phone, code) {
    return request.post(
      '/api/v1/auth/login/phone',
      {
        phone,
        code,
        device_fingerprint: getDeviceFingerprint()
      },
      {
        showError: false
      }
    )
  },

  cmiLogin(data) {
    return request.post(
      '/api/v1/auth/login/cmi',
      { data },
      {
        showError: false,
        skipAuth: true
      }
    )
  },

  oauthLogin(provider, oauthCode) {
    return request.post('/api/v1/auth/login/oauth', {
      provider,
      oauth_code: oauthCode,
      device_fingerprint: getDeviceFingerprint()
    })
  },

  refreshToken(refreshToken) {
    return request.post(
      '/api/v1/auth/token/refresh',
      {
        refresh_token: refreshToken,
        device_fingerprint: getDeviceFingerprint()
      },
      {
        showError: false,
        skipAuth: true
      }
    )
  },

  logout(refreshToken = null) {
    return request.post('/api/v1/auth/logout', {
      refresh_token: refreshToken,
      device_fingerprint: getDeviceFingerprint()
    })
  }
}

const SubscriptionAPI = {
  getStatus(config = {}) {
    return request.get('/api/v1/subscription/status', {}, config)
  },

  getProducts(params = {}) {
    return request.get('/api/v1/subscription/products', params)
  },

  createPurchase(payload) {
    return request.post('/api/v1/subscription/purchase', payload)
  },

  getPurchases(params = {}) {
    return request.get('/api/v1/subscription/purchases', params)
  },

  getTrialRemaining() {
    return request.get('/api/v1/subscription/trial/remaining')
  },

  consumeTrial(payload) {
    return request.post('/api/v1/subscription/trial/consume', payload)
  },

  redeemBenefit(payload, config = {}) {
    return request.post('/api/v1/subscription/redeem', payload, config)
  }
}

const UsageAPI = {
  getQuota() {
    return request.get('/api/v1/ai_menu/quota')
  }
}

const AiMenuAPI = {
  translateImage(payload) {
    return request.post('/api/v1/ai_menu/translate', payload, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  }
}

const WeChatPayAPI = {
  createOrder(payload, config = {}) {
    return request.post('/api/v1/wechat/pay/orders', payload, config)
  },

  queryOrder(outTradeNo, config = {}) {
    return request.get(`/api/v1/wechat/pay/orders/${encodeURIComponent(outTradeNo)}`, {}, config)
  }
}

const API = {
  auth: AuthAPI,
  subscription: SubscriptionAPI,
  usage: UsageAPI,
  aiMenu: AiMenuAPI,
  wechatPay: WeChatPayAPI
}

export default API
export {
  AuthAPI,
  SubscriptionAPI,
  UsageAPI,
  AiMenuAPI,
  WeChatPayAPI
}
